import SolarIcon from 'components/icons/SolarIcon';
import { UserSelected } from 'modules/user';
import type { TaskFilterModel } from '../model/useTaskFilter';
import TaskFilterPicker from './TaskFilterPicker';

interface TaskFilterUsersProps {
    filter: TaskFilterModel;
    showExecutorFilter: boolean;
    showControllerFilter: boolean;
}

const TaskFilterUsers = ({
    filter,
    showExecutorFilter,
    showControllerFilter,
}: TaskFilterUsersProps) => {
    const {
        t,
        draftExecutorUser,
        draftControllerUser,
        draftExecutorPickerOpen,
        draftControllerPickerOpen,
        setDraftExecutorPickerOpen,
        setDraftControllerPickerOpen,
        handleChangeExecutor,
        handleChangeController,
    } = filter;

    return (
        <>
            {showExecutorFilter ? (
                <TaskFilterPicker
                    open={draftExecutorPickerOpen}
                    hasValue={Boolean(draftExecutorUser)}
                    icon="person"
                    pickLabel={t('filterPickExecutor')}
                    cancelLabel={t('filterCancelPick')}
                    onOpen={() => setDraftExecutorPickerOpen(true)}
                    onCancel={() => setDraftExecutorPickerOpen(false)}
                >
                    {(cancelButton) => (
                        <UserSelected
                            value={draftExecutorUser}
                            onChange={handleChangeExecutor}
                            title={
                                <>
                                    <SolarIcon name="person" className="me-1" />
                                    {t('labelExecutor')}
                                </>
                            }
                            maxHeight={180}
                            smallMode
                            className="mb-0"
                            rightElement={cancelButton}
                        />
                    )}
                </TaskFilterPicker>
            ) : null}

            {showControllerFilter ? (
                <TaskFilterPicker
                    open={draftControllerPickerOpen}
                    hasValue={Boolean(draftControllerUser)}
                    icon="clipboard-check"
                    pickLabel={t('filterPickController')}
                    cancelLabel={t('filterCancelPick')}
                    onOpen={() => setDraftControllerPickerOpen(true)}
                    onCancel={() => setDraftControllerPickerOpen(false)}
                >
                    {(cancelButton) => (
                        <UserSelected
                            value={draftControllerUser}
                            onChange={handleChangeController}
                            title={
                                <>
                                    <SolarIcon name="clipboard-check" className="me-1" />
                                    {t('labelController')}
                                </>
                            }
                            maxHeight={180}
                            smallMode
                            className="mb-0"
                            rightElement={cancelButton}
                        />
                    )}
                </TaskFilterPicker>
            ) : null}

            {draftExecutorUser && draftControllerUser ? (
                <div className="text-muted mb-2" style={{ fontSize: '0.65rem', lineHeight: 1.35 }}>
                    {t('filterUsersOrHint')}
                </div>
            ) : null}
        </>
    );
};

export default TaskFilterUsers;
